import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-left: ', 'px;\n  min-width: ', 'px;\n\n  ', ' ', ';\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-left: ', 'px;\n  min-width: ', 'px;\n\n  ', ' ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    margin-top: ', 'px;\n  '], ['\n    margin-top: ', 'px;\n  ']);

import styled from 'styled-components';
import { gridSize } from '../../shared-variables';
import { whenCollapsed, whenNotInOverflowDropdown } from '../../theme/util';

var NavigationItemGroupAction = styled.div(_templateObject, gridSize / 2, gridSize * 3, whenCollapsed(_templateObject2), whenNotInOverflowDropdown(_templateObject3, gridSize));

NavigationItemGroupAction.displayName = 'NavigationItemGroupAction';
export default NavigationItemGroupAction;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/styled/NavigationItemGroupAction.js
// module id = 625
// module chunks = 0